import { render } from "./SessionCardDialog.vue?vue&type=template&id=1d7c5e54&scoped=true"
import script from "./SessionCardDialog.vue?vue&type=script&lang=js"
export * from "./SessionCardDialog.vue?vue&type=script&lang=js"

import "./SessionCardDialog.vue?vue&type=style&index=0&id=1d7c5e54&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d7c5e54"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
